import { createMutationHook } from '../client';
import { createP1DongleInstallationReminder } from '../services/DongleAgreementService';

export const useDongleAgreementCreateP1DongleInstallationReminder = createMutationHook(
  createP1DongleInstallationReminder,
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: false },
);
